/**
 * 🔧 유지보수 계약현황 통합검색 (v2.271.0) — 영업진행·매입관리 목록의 검색창과 같은 동작.
 *
 *   - 검색어 앞뒤 공백을 떼고, 대소문자 없이 「글자가 들어 있으면」 맞는다
 *     (영업진행·매입관리 서버의 `ILIKE '%검색어%'` 와 같은 뜻 · 여러 칸 중 하나만 맞아도 된다).
 *   - 영업진행·매입관리는 서버가 거르지만, 이 목록은 그 해 계약을 한 번에 다 받아 오므로 화면에서 거른다.
 *     ⭐그래서 조회 전용(viewer)에게는 **서버가 이미 가린 글**(비고 속 금액 「***」)만 훑는다 —
 *       금액 숫자로 찾아서 어느 계약인지 맞혀 보는 길이 없다. 금액 칸(null)은 아예 훑지 않는다.
 */

import type { MaintenanceContractRow } from './types';

/** 훑는 칸 — 표에 보이는 글 칸 + 계약명(계산서 발행정보)·계약번호·입찰공고 건명·대상 장비 */
export const MAINT_SEARCH_FIELDS: { label: string; get: (r: MaintenanceContractRow) => string | null | undefined }[] = [
  { label: '고객사', get: (r) => r.endUser },
  { label: '청구업체', get: (r) => r.contractCompany },
  { label: '확약/낙찰업체', get: (r) => r.awardCompany },
  { label: '계약명', get: (r) => r.contractName },
  { label: '계약번호', get: (r) => r.contractNo },
  { label: '입찰공고 건명', get: (r) => r.bidTitle },
  { label: '비고', get: (r) => r.note },
  { label: 'PM', get: (r) => r.pmName },
  { label: '엔지니어', get: (r) => r.engineerName },
  { label: '대상 장비', get: (r) => r.targetEquipment },
  { label: '계산서 발행 약정', get: (r) => r.invoiceSchedule },
];

/** 검색어로 거른 줄 — 빈 검색어면 받은 배열 그대로(같은 참조). 순서는 바꾸지 않는다. */
export function filterMaintRows<T extends MaintenanceContractRow>(rows: T[], query: string): T[] {
  const term = query.trim().toLowerCase();
  if (term === '') return rows;
  return rows.filter((r) => MAINT_SEARCH_FIELDS.some((f) => (f.get(r) ?? '').toLowerCase().includes(term)));
}

/** 검색창 자동완성 후보 — 고객사·청구업체·확약/낙찰업체·입찰공고 건명·계약번호 (영업진행처럼 이름 위주 · 긴 글 칸은 뺀다) */
export function maintSearchSuggestions(rows: MaintenanceContractRow[]): string[] {
  const set = new Set<string>();
  for (const r of rows) {
    for (const v of [r.endUser, r.contractCompany, r.awardCompany, r.bidTitle, r.contractNo]) {
      const s = (v ?? '').trim();
      if (s) set.add(s);
    }
  }
  return [...set];
}
